import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

const occasions = [
  {
    name: 'Office Wear',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Indian%20woman%20in%20elegant%20formal%20kurta%20with%20gold%20plated%20Korean%20minimal%20dainty%20chain%20necklace%2C%20close%20up%20three%20quarter%20angle%20shot%2C%20professional%20office%20corridor%20background%20with%20soft%20natural%20light%20pouring%20through%20windows%2C%20editorial%20fashion%20photography%2C%20warm%20neutral%20cream%20tones%2C%20subtle%20gold%20reflection%20on%20jewellery%2C%20clean%20sophisticated%20aesthetic&width=600&height=600&seq=occasion-office-v2&orientation=squarish',
  },
  {
    name: 'Daily Wear',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Indian%20woman%20wearing%20casual%20cotton%20kurta%20with%20gold%20plated%20multi%20layer%20layered%20necklaces%20stacked%20together%2C%20lifestyle%20photography%20shot%20from%20slightly%20above%20angle%2C%20warm%20afternoon%20sunlight%20in%20home%20balcony%20setting%20with%20soft%20greenery%20behind%2C%20relaxed%20everyday%20elegance%2C%20editorial%20fashion%2C%20soft%20ivory%20background%2C%20warm%20golden%20tones%20on%20stainless%20steel%20jewellery%20reflecting%20light&width=600&height=600&seq=occasion-daily-v2&orientation=squarish',
  },
  {
    name: 'Campus & Active',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20young%20Indian%20woman%20in%20modern%20campus%20wear%20casual%20shirt%20and%20jeans%20with%20gold%20plated%20minimal%20pearl%20drop%20earrings%20and%20delicate%20pearl%20pendant%20necklace%2C%20candid%20side%20profile%20angle%20shot%2C%20outdoor%20university%20campus%20background%20with%20brick%20buildings%20and%20trees%20in%20soft%20focus%2C%20natural%20daylight%2C%20fresh%20youthful%20editorial%20photography%2C%20soft%20pastel%20beige%20background%20tones%2C%20subtle%20jewellery%20shimmer&width=600&height=600&seq=occasion-campus-v2&orientation=squarish',
  },
  {
    name: 'Date Night',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Indian%20woman%20in%20elegant%20fusion%20kurta%20outfit%20with%20gold%20plated%20personalized%20charm%20necklace%20featuring%20a%20delicate%20letter%20pendant%2C%20intimate%20close%20up%20front%20facing%20angle%20with%20soft%20eye%20contact%2C%20warm%20romantic%20evening%20ambient%20lighting%20at%20upscale%20restaurant%20setting%2C%20candlelit%20warm%20golden%20glow%2C%20editorial%20fashion%20photography%2C%20rich%20warm%20beige%20and%20cream%20tones%2C%20stainless%20steel%20gold%20jewellery%20gleaming%20softly&width=600&height=600&seq=occasion-date-v2&orientation=squarish',
  },

];

export default function ShopByOccasion() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-none mx-auto px-4 md:px-6">
        <ScrollReveal>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-primary-500 text-center mb-2">
            Shop by Occasion
          </h2>
          <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-12 font-label">
            Jewellery that fits your every moment
          </p>
        </ScrollReveal>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {occasions.map((occasion, idx) => (
            <ScrollReveal key={occasion.name} delay={idx * 80}>
              <Link
                to={`/shop?occasion=${encodeURIComponent(occasion.name)}`}
                className="group relative aspect-square rounded-2xl overflow-hidden bg-secondary-100 cursor-pointer"
              >
                <img
                  src={occasion.image}
                  alt={occasion.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-500/70 via-primary-500/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <span className="text-sm md:text-base font-heading font-semibold text-background-50">
                    {occasion.name}
                  </span>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}